import { render, staticRenderFns } from "./fileTask.vue?vue&type=template&id=e8c51bb4&scoped=true"
import script from "./fileTask.vue?vue&type=script&lang=js"
export * from "./fileTask.vue?vue&type=script&lang=js"
import style0 from "./fileTask.vue?vue&type=style&index=0&id=e8c51bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c51bb4",
  null
  
)

export default component.exports